import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { environment } from '@env/environment';
import { Options } from '@shared/models/options';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class SalesDataApi extends ApiCommon {
  protected backend = environment.api.backend;

  getSalesDataList(pageEvent, opt?: Options): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }

    if (opt?.query) {
      builder.query = opt.query;
    }

    builder.startDate = opt.startDate
    builder.endDate = opt.endDate

    return this.apiServer.salesData.getSalesDataList(builder.build());
  }

  deleteAllSalesData(): Observable<any> {
    return this.apiServer.salesData.deleteAllSalesData();
  }

  deleteSalesData(productType, year, month): Observable<any> {
    return this.apiServer.salesData.deleteSalesData(productType, year, month);
  }
}
